import { UnknownAction } from "redux-saga";
import {NDA} from "../../types/nda";
import {
  FETCHING_NDA_TEMPLATES_SUCCEEDED,
  FETCH_NDA_TEMPLATES_REQUEST,
  FETCHING_NDA_TEMPLATES_FAILED,
} from "../actions/actionTypes";

type Action = UnknownAction;

interface NDATemplateState {
    fetching: boolean;
    fetched : boolean;
    items: NDA[];
    error: any;
  }

const initialNDATemplatesState: NDATemplateState = {
    fetching: false,
    items: [],
    error: null,
    fetched : false
  };
  
  export const ndaReducer = (state = initialNDATemplatesState, action: Action) => {
    switch (action.type) {
      case FETCH_NDA_TEMPLATES_REQUEST: {
        return {
          ...state,
          fetching: true,
          fetched : false
        };
      }
      case FETCHING_NDA_TEMPLATES_SUCCEEDED: {
        const response = action.payload as NDA[];
        return {
          ...state,
          items: response,
          fetching: false,
          fetched:true
        };
      }
      case FETCHING_NDA_TEMPLATES_FAILED: {
        return {
          ...state,
          fetching: false,
          error: action.payload,
          fetched:false
        };
      }
      default:
        return state;
    }
  };
  